/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import { USER } from '@/store/types';
import * as api from '@/api/user';
import { createPayment } from '@/utils/create-payment';
import { UserCouple } from '@/api/types/user';

export interface StoreUserCoupleState {
  couple: UserCouple | null;
  extra: {
    count2: number;
  };
}

export default {
  namespaced: true,
  state: {
    couple: [],
    extra: null,
  },
  actions: {
    [USER.GET_CP]({ commit }) {
      return new Promise((resolve, reject) => {
        api.getCp().then((res) => {
          commit(USER.GET_CP, res);
          resolve();
        }).catch(reject);
      });
    },
    [USER.DEL_CP]({ dispatch }) {
      return new Promise((resolve, reject) => {
        createPayment(() => api.delCp({ errcodeExpected: [445, 446] })).then(() => {
          dispatch(USER.GET_CP);
          resolve();
        }).catch(reject);
      });
    },
    [USER.SET_CP]({ dispatch }, { name }) {
      return new Promise((resolve, reject) => {
        createPayment(() => api.setCp(name, { errcodeExpected: [445, 446] })).then(() => {
          dispatch(USER.GET_CP);
          resolve();
        }).catch(reject);
      });
    },
  },
  mutations: {
    [USER.GET_CP](state, data) {
      state.couple = data.data;
      state.extra = data.extra;
    },
  },
};
